import Vue from 'vue';
import Vuex from 'vuex';
import {
  STORE_MODULES,
} from './store-modules';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {},
  actions: {},
  modules: STORE_MODULES,
});
